/**
 * Status badge component with color coding per task status.
 */

import type { TaskStatus } from 'scheduler-types';
import { getStatusLabel } from '../lib/format';

interface StatusBadgeProps {
  status: TaskStatus;
  size?: 'sm' | 'md';
}

const statusStyles: Record<TaskStatus, string> = {
  pending: 'bg-status-pending/20 text-status-pending',
  ready: 'bg-status-ready/20 text-status-ready',
  staged: 'bg-status-staged/20 text-status-staged',
  partial_staged: 'bg-amber-500/20 text-amber-400',
  in_progress: 'bg-status-in-progress/20 text-status-in-progress',
  complete: 'bg-status-complete/20 text-status-complete',
  cancelled: 'bg-status-cancelled/20 text-status-cancelled',
  abandoned: 'bg-status-cancelled/20 text-status-cancelled',
};

export function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-2xs' : 'px-2.5 py-1 text-xs';

  return (
    <span
      className={`
        inline-flex items-center rounded font-semibold uppercase tracking-wider
        ${sizeClasses}
        ${statusStyles[status]}
      `}
    >
      {getStatusLabel(status)}
    </span>
  );
}
